import { FreeplayEntry, FreeplayUser, OverviewEvent, PlatformEvent, PlatformOffer } from "@freeplay/shared-code";
import React, { useEffect, useState } from "react";
import { useScrollToTop } from "../components/hooks/scrollToTopHook";
import { useServices } from "../contexts/ServiceContext";
import { PickOverviewView } from "../views/PickOverviewView";
import { useApplication } from "../contexts/ApplicationContext";
import { useEvent } from "../contexts/EventContext";
import { MixPanelEventEnum, useMixpanel } from "../utils/analytics";

export const PickOverviewController = (): JSX.Element => {
    const {
        appDispatch,
        appState: { freeplayFocusedExperience },
    } = useApplication();
    const { currentEvent, currentEntry } = useEvent();
    const [user, setUser] = useState<FreeplayUser>();
    const [eventsToDisplay, setEventsToDisplay] = useState<{
        events: OverviewEvent[];
        name: string;
        bettingEnds: string;
        betOutcomes?: FreeplayEntry;
    }>({
        events: [],
        name: "",
        bettingEnds: "",
    });
    const { fpUser } = useServices();
    useScrollToTop();
    useEffect(() => {
        if (fpUser || freeplayFocusedExperience) {
            setUser(fpUser);
            appDispatch({ type: "setLoginButtonVisible", buttonVisible: false, buttonString: "" });
        } else {
            appDispatch({ type: "setLoginButtonVisible", buttonVisible: true, buttonString: "Login to Submit Picks" });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fpUser, freeplayFocusedExperience]);

    useMixpanel(
        fpUser ? MixPanelEventEnum.PICK_OVERVIEW_SCREEN_VIEWED : MixPanelEventEnum.UNAUTHED_OVERVIEW_SCREEN_VIEWED,
        currentEvent?.id ?? -1,
    );
    useEffect(() => {
        if (!currentEvent) {
            return;
        }
        const returnEvents: OverviewEvent[] = [];
        currentEvent.platformEvents.forEach((platformEvent: PlatformEvent, index: number) => {
            platformEvent.platformOffers.forEach((platformOffer: PlatformOffer) => {
                const returnEvent: Partial<OverviewEvent> & { platformEvents?: PlatformEvent[] } = {
                    ...platformEvent,
                };
                delete returnEvent.platformEvents;
                returnEvent.offer = platformOffer;
                returnEvents.push(returnEvent as OverviewEvent);
            });
        });
        setEventsToDisplay({
            events: returnEvents,
            name: currentEvent.name,
            bettingEnds: currentEvent.bettingEnds,
            betOutcomes: currentEntry,
        });
    }, [currentEvent, currentEntry]);

    if (!eventsToDisplay) {
        return <p>Loading</p>;
    }

    return <PickOverviewView isUser={!!user} />;
};
